import React from 'react';
import _ from 'lodash';
import ChipInput from 'material-ui-chip-input'


export default class ChipField extends React.Component {

  constructor(props) {
    super(props);
    var value = {};//this.props.value ? this.props.value : {};
    var selected = [];
    this.state = { value, selected };
    
  }

  componentWillReceiveProps = (e) => {
    
    if (e.value)
    {
      var value = e.value ? e.value : {};
      if (value != this.state.value)
      {
        this.setValueState(value);
      }
    }
  }
    
  handleRequestAdd = (event) => {
    var value = {...this.state.value, [event.key]:{selected:true}};
    this.setValueState(value);
  };

  handleRequestDelete = (event) => {
    //var value = this.state.value.filter( (o) => (o !== event));
    var value = _.omit(this.state.value, event)
    this.setValueState(value);    
  };

  setValueState = (value) => {
    
    var selected = Object.keys(value).map( (id) => { return this.getOption(id); } ).filter( (o) => !!o);    
    this.setState({ value, selected }, () => {
      if (this.props.onChange)
      {
        this.props.onChange(this.state.selected);
      }
    });
  }

  getOption = (key) => {
    return this.props.options.filter( (o) => (o && o.key === key) ).pop();
  }

  render() {
    var {floatingLabelFixed } = this.props;
    return (
      <ChipInput
        fullWidth 
        inputStyle={{width: 50}} 
        
        floatingLabelFixed={floatingLabelFixed}
        openOnFocus={true}
        menuProps={{desktop:true, className: "chipinput__menu"}}
        menuStyle={{desktop:true,maxHeight:240, overflowY:'auto'}}
        dataSourceConfig={{text: 'name', value: 'key'}}
        floatingLabelText={this.props.label}
        onRequestAdd={this.handleRequestAdd}
        onRequestDelete={this.handleRequestDelete}
        fullWidth={true}
        value={this.state.selected}
        dataSource={this.props.options}
         />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/ChipField.jsx